import React from "react";
import { Route } from "react-router-dom";

// Makes sure that logged out routes are not accessible to logged in users
export const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      <Component {...props} />
    }
  />
);
